import { render, staticRenderFns } from "./BaseGallery.vue?vue&type=template&id=b0f4912a&"
import script from "./BaseGallery.vue?vue&type=script&lang=js&"
export * from "./BaseGallery.vue?vue&type=script&lang=js&"
import style0 from "./BaseGallery.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports